import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const OrganizationProgramPage = lazy(() =>
  import("./OrganizationProgramPage").then((module) => ({ default: module.OrganizationProgramPage })),
);

export function OrganizationProgramAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <OrganizationProgramPage />
    </Suspense>
  );
}
